import { render, staticRenderFns } from "./Server.vue?vue&type=template&id=d6e510cc&scoped=true"
import script from "./Server.vue?vue&type=script&lang=js"
export * from "./Server.vue?vue&type=script&lang=js"
import style0 from "./Server.vue?vue&type=style&index=0&id=d6e510cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e510cc",
  null
  
)

export default component.exports